import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="px-5 py-24 md:py-32" data-id="element-107">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="mx-auto max-w-3xl rounded-2xl border border-[#625237] bg-[#171B16] p-9 text-center md:p-14" data-id="element-108">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 bg-gold/10" data-id="element-109">
          <ShieldCheckIcon className="h-7 w-7 text-gold-light" data-id="element-110" />
        </span>
        <h2 className="mt-6 text-4xl font-semibold text-stone-light md:text-5xl" data-id="element-111">
          Garantía de satisfacción de 7 días
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-7 text-stone" data-id="element-112">
          Si la colección no cumple tus expectativas puedes solicitar la
          devolución de tu dinero dentro de los 7 días posteriores a tu compra.
        </p>
      </motion.div>
    </section>;
}